"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var MediaDeviceProxyHandler_1 = require("./MediaDeviceProxyHandler");
var DefaultMediaDeviceFactory = /*#__PURE__*/function () {
  function DefaultMediaDeviceFactory() {
    _classCallCheck(this, DefaultMediaDeviceFactory);
    this.isMediaDevicesSupported = typeof navigator !== 'undefined' && !!navigator.mediaDevices;
  }
  _createClass(DefaultMediaDeviceFactory, [{
    key: "create",
    value: function create() {
      if (!this.isMediaDevicesSupported) {
        throw new Error("navigator.mediaDevices is not supported");
      } else {
        return new Proxy(navigator.mediaDevices, new MediaDeviceProxyHandler_1.default());
      }
    }
  }]);
  return DefaultMediaDeviceFactory;
}();
exports.default = DefaultMediaDeviceFactory;